import { render, staticRenderFns } from "./CustomSwitchFilter.vue?vue&type=template&id=43f78564&scoped=true&"
import script from "./CustomSwitchFilter.vue?vue&type=script&lang=js&"
export * from "./CustomSwitchFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwitchFilter.vue?vue&type=style&index=0&id=43f78564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f78564",
  null
  
)

export default component.exports